import React, { useState } from "react";
import EditQuestionCategoryModal from "../modals/EditQuestionCategoryModal";
import TagCard from "resources/questionCategory/list/components/TagCard";
import CreateTagButton from "resources/questionCategory/list/components/CreateTagButton";
import QuestionSubcategoryCard from "resources/questionCategory/list/components/QuestionSubcategoryCard";
import CreateSubcategoryButton from "resources/questionCategory/list/components/CreateSubcategoryButton";
import { useGetList } from "react-admin";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary, Box,
  Button,
  CardActions,
  Menu, MenuItem,
  Stack,
  Typography
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DeleteEntityModal from "components/category/DeleteEntityModal";

interface QuestionCategoryCardProps {
  category: { id: string; title: string };
}

const QuestionCategoryCard = ({ category }: QuestionCategoryCardProps) => {
  const { data: tagData } = useGetList(
    "tag",
    {
      pagination: { page: 0, perPage: 1000 },
      filter: { questionCategoryId: category.id },
    },
  );

  const { data: questionSubcategoryData } = useGetList(
    "question-subcategory",
    {
      pagination: { page: 0, perPage: 1000 },
      filter: { category: category.id },
    },
  )

  const [expanded, setExpanded] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);

  const handleToggleAccordion = () => setExpanded(!expanded);
  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  const handleEdit = () => {
    setEditModalOpen(true);
    handleMenuClose();
  };

  const handleDelete = () => {
    setDeleteModalOpen(true);
    handleMenuClose();
  };

  const handleCloseEditModal = () => setEditModalOpen(false);
  const handleCloseDeleteModal = () => setDeleteModalOpen(false);

  return (
    <Accordion expanded={expanded} onChange={handleToggleAccordion} disableGutters>
      <AccordionSummary expandIcon={<ExpandMoreIcon/>} sx={{ m: 0 }}>
        <Stack>
          <Typography variant="h6">{category.title}</Typography>
          {/*{"type" in category && category?.type && (*/}
          {/*  <Chip*/}
          {/*    sx={{ width: 'fit-content' }}*/}
          {/*    size="small"*/}
          {/*    label={MATERIAL_TYPE_TITLE[category?.type]}*/}
          {/*  />*/}
          {/*)}*/}
        </Stack>
      </AccordionSummary>
      <AccordionDetails>
        <CardActions sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button onClick={handleMenuOpen}>Управление категорией</Button>
          <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
            <MenuItem onClick={handleEdit}>Редактировать категорию</MenuItem>
            <MenuItem onClick={handleDelete}>Удалить категорию</MenuItem>
          </Menu>
        </CardActions>
        <Box display="flex" flexDirection="column" gap={2}>
          <Box display="flex" flexDirection="column" gap={2}>
            {
              tagData?.length
                ? tagData?.map((item) => (
                  <TagCard key={item.id} tag={item} category={category}/>
                ))
                : (<Typography>Нет тегов</Typography>)
            }
            <CreateTagButton category={category}/>
          </Box>
          <Box display="flex" flexDirection="column" gap={2}>
            {
              questionSubcategoryData?.length
                ? questionSubcategoryData
                  ?.sort(
                    (a, b) => (a?.position ?? 0) - (b?.position ?? 0)
                  )
                  ?.map((
                    item) => (<QuestionSubcategoryCard key={item.id} item={item}/>)
                  )
                : (
                  <Typography>
                    Нет подкатегорий
                  </Typography>
                )
            }
            <CreateSubcategoryButton category={category}/>
          </Box>
        </Box>
      </AccordionDetails>

      {
        isEditModalOpen && (
          <EditQuestionCategoryModal isOpen={isEditModalOpen} onClose={handleCloseEditModal} category={category}/>
        )
      }
      {
        isDeleteModalOpen && (
          <DeleteEntityModal
            entityText={{
              title: "Удалить категорию",
              success: "Категория удалена",
              error: "Ошибка при удалении категории"
            }}
            resource='question-category'
            isOpen={isDeleteModalOpen}
            onClose={handleCloseDeleteModal}
            entity={category}
          />
        )
      }
    </Accordion>
  );
};

export default QuestionCategoryCard;
